import React, { useEffect, useState } from "react";
import HeaderAdmin from "../../../Components/HeaderAdmin/Header";
import { Link } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { ShippingStGet } from "../../../Api/ShippingSt";

function ShipStationList() {
    const [ShippingDta, setShippingDta] = useState([]);

    useEffect(() => {
        getDataById();
    }, []);

    const getDataById = () => {
        ShippingStGet()
            .then((res) => {
                const Data = res.data.data;
                setShippingDta(Data);
            })
            .catch((err) => {
                alert("Error fetching data: " + err);
            });
    };


    return (
        <>
            <div className="main-page-body-content-header">
                <HeaderAdmin />
            </div>

            <div className="dashboard-container d-flex">
                <div className="main-container">
                    <div className="main-page-body-content">
                        <div className="main-page-body-content-body">
                            <div className="main-page-body-content-body-container">
                                <div className="container-fluid">
                                    <div className="sec-header-dash">
                                        <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                            <h3>Station List</h3>
                                        </div>
                                        <div className="content-box-btn">
                                            <Link to="/shipstation-add">
                                                <button className="btn btn-add">Add</button>
                                            </Link>
                                        </div>
                                    </div>
                                    {ShippingDta.map((item, index) => (
                                        <div className="form-box-section mt-3" key={index}>
                                            <div className="profile">
                                                <div className="profile-details">
                                                    <div className="user-name">
                                                        <h3>{item.Shipping_Stations_name}</h3>
                                                    </div>
                                                    <div className="user-email">
                                                        {item.Shipping_Stations_id}
                                                    </div>
                                                </div>
                                                <div className="content-box-btn">
                                                    <Link to={`/shipstation-view/${item._id}`}>
                                                        <button className="btn btn-edit"><FaEye /></button>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ShipStationList;
